module.exports = __webpack_public_path__ + "static/media/14.113b8e92.JPG";